// extracted by mini-css-extract-plugin
export default {"tooltip":"GW-z","arrow":"HW-z"};